function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawWindTurbine = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1144 727.23",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 241.37,
    y1: 811.22,
    x2: 241.37,
    y2: 492.1,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M1144 461.33a244.4 244.4 0 0 1-6.85 57.75 228.14 228.14 0 0 1-19.26 51.53 147.47 147.47 0 0 1-147.65 147.67H217.17A188.29 188.29 0 0 1 49.25 614.95a187.1 187.1 0 0 1-20.11-84.68C10.72 497.27 0 457.8 0 415.36c0-115.43 79.24-209 177-209 3.46 0 6.9.13 10.31.36C248.65 84.93 387 0 547.74 0c98.82 0 189.15 32.08 258.35 85.08 25.44-16.71 54.73-26.25 85.9-26.25 97.75 0 177 93.58 177 209q0 11.08-1 21.86c45.95 37.76 76.01 100.55 76.01 171.64z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M575.59 205.49c-1.18 6.48-5.17 20.16-18.06 19.82-9.84-.25-17.42-8.84-17.16-18.68l3.71-134 1.21-43.7s6.38-12.09 12.73 42.11v.2l17.64 128.52a18 18 0 0 1-.07 5.73z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M548.06 218.5H567v40.51h-18.94z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M550.39 249.39h14.57v17.78h-14.57z"
  }), React.createElement("path", {
    d: "M558.05 71.25c-6.63-1.93-11.14-.46-14 1.39l1.21-43.7s6.38-12.09 12.73 42.11zM567 230.61v28.4h-18.94v-27.84a25.6 25.6 0 0 1 18.94-.56z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M611.59 320.9c-5.31-3.9-15.85-13.48-9.9-24.92 4.54-8.73 15.58-11.79 24.31-7.24l118.81 62.08 38.75 20.24s8.06 11-43.44-7l-.19-.06-123.25-40.5a18.28 18.28 0 0 1-5.09-2.6z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M567.263 289.73l8.303-17.024 36.41 17.759-8.303 17.023z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M583.188 279.018l-6.387 13.095-15.98-7.794 6.386-13.095z"
  }), React.createElement("path", {
    d: "M739.93 363.99c4.64-5.12 5.3-9.82 4.88-13.17l38.75 20.24s8.06 11-43.44-7zM592.79 302.17l-25.53-12.45 8.3-17 25 12.2a25.59 25.59 0 0 1-7.77 17.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M503.47 320.9c5.31-3.9 15.85-13.48 9.9-24.92-4.54-8.73-15.58-11.79-24.31-7.24l-118.81 62.08-38.75 20.24s-8.06 11 43.44-7l.19-.06 123.25-40.49a18.28 18.28 0 0 0 5.09-2.61z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M503.085 290.461l36.41-17.758 8.302 17.023-36.41 17.758z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M547.85 271.219l6.387 13.095-15.98 7.794-6.388-13.095z"
  }), React.createElement("path", {
    d: "M375.13 363.99c-4.64-5.12-5.3-9.82-4.88-13.17l-38.75 20.24s-8.06 11 43.44-7zM522.27 302.17l25.53-12.45-8.3-17-25 12.2a25.59 25.59 0 0 0 7.77 17.25z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#fff",
    d: "M574.57 717.37h-37.15l11.8-437.53h13.55l11.8 437.53z"
  }), React.createElement("circle", {
    cx: 557.53,
    cy: 274.45,
    r: 12.38,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M850.67 182.43c-.79 4.38-3.49 13.63-12.21 13.4a12.19 12.19 0 0 1-11.62-12.63l2.52-90.66.81-29.56s4.32-8.18 8.62 28.49v.13l11.93 87a12.26 12.26 0 0 1-.05 3.83z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M832.05 191.22h12.81v27.41h-12.81z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M833.62 212.12h9.86v12.03h-9.86z"
  }), React.createElement("path", {
    d: "M838.81 91.61c-4.49-1.3-7.54-.31-9.45.94l.81-29.56s4.32-8.18 8.62 28.49zM844.86 199.41v19.2h-12.81V199.8a17.29 17.29 0 0 1 12.81-.39z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M875 260.5c-3.59-2.63-10.73-9.11-6.7-16.85a12.18 12.18 0 0 1 16.45-4.9l80.38 42 26.21 13.69s5.46 7.47-29.38-4.74h-.13l-83.39-27.39a12.33 12.33 0 0 1-3.44-1.81z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M845.036 239.415l5.616-11.514 24.636 12.016-5.616 11.513z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M855.82 232.174l-4.322 8.862-10.812-5.273 4.322-8.863z"
  }), React.createElement("path", {
    d: "M961.86 289.66c3.14-3.46 3.59-6.64 3.3-8.91l26.21 13.69s5.46 7.47-29.38-4.74zM862.31 247.84L845 239.41l5.61-11.51 16.93 8.25a17.35 17.35 0 0 1-5.23 11.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M801.88 260.5c3.59-2.63 10.73-9.11 6.7-16.85a12.18 12.18 0 0 0-16.45-4.9l-80.38 42-26.21 13.69s-5.46 7.47 29.38-4.74h.13l83.39-27.39a12.33 12.33 0 0 0 3.44-1.81z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M801.628 239.921l24.636-12.016 5.616 11.514-24.636 12.016z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M831.906 226.893l4.322 8.862-10.812 5.274-4.323-8.862z"
  }), React.createElement("path", {
    d: "M715.05 289.66c-3.14-3.46-3.59-6.64-3.3-8.91l-26.21 13.69s-5.46 7.47 29.38-4.74zM814.6 247.84l17.27-8.43-5.61-11.51-16.93 8.25a17.35 17.35 0 0 0 5.27 11.69z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#fff",
    d: "M849.99 528.74l-25.26 4.44 8.1-300.45H842l7.99 296.01z"
  }), React.createElement("circle", {
    cx: 838.46,
    cy: 229.08,
    r: 8.38,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M277.51 182.43c-.79 4.38-3.49 13.63-12.21 13.4a12.18 12.18 0 0 1-11.61-12.63l2.51-90.66.81-29.56s4.32-8.18 8.62 28.49v.13l11.94 87a12.56 12.56 0 0 1-.06 3.83z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M258.89 191.22h12.81v27.41h-12.81z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M260.46 212.12h9.86v12.03h-9.86z"
  }), React.createElement("path", {
    d: "M265.65 91.61c-4.48-1.3-7.54-.31-9.45.94l.81-29.56s4.32-8.18 8.62 28.49zM271.7 199.41v19.2h-12.81V199.8a17.29 17.29 0 0 1 12.81-.39z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M301.87 260.5c-3.59-2.63-10.72-9.11-6.69-16.85a12.17 12.17 0 0 1 16.44-4.9l80.38 42 26.22 13.69s5.45 7.47-29.39-4.74h-.13l-83.38-27.39a12.39 12.39 0 0 1-3.45-1.81z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M271.88 239.417l5.615-11.513 24.636 12.016-5.615 11.513z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M282.657 232.171l-4.322 8.862-10.813-5.273 4.323-8.862z"
  }), React.createElement("path", {
    d: "M388.7 289.66c3.14-3.46 3.59-6.64 3.3-8.91l26.22 13.69s5.45 7.47-29.39-4.74zM289.15 247.84l-17.27-8.43 5.62-11.51 16.92 8.25a17.31 17.31 0 0 1-5.27 11.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M228.72 260.5c3.6-2.63 10.73-9.11 6.7-16.85a12.18 12.18 0 0 0-16.45-4.9l-80.38 42-26.21 13.69s-5.46 7.47 29.38-4.74h.13l83.39-27.39a12.33 12.33 0 0 0 3.44-1.81z",
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M228.465 239.918l24.636-12.016 5.616 11.514-24.636 12.016z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M258.754 226.9l4.322 8.861-10.813 5.274-4.322-8.862z"
  }), React.createElement("path", {
    d: "M141.89 289.66c-3.13-3.46-3.58-6.64-3.3-8.91l-26.21 13.69s-5.46 7.47 29.38-4.74zM241.44 247.84l17.27-8.43-5.61-11.51-16.93 8.25a17.4 17.4 0 0 0 5.27 11.69z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#fff",
    d: "M276.83 528.74h-25.14l7.99-296.01h9.16l7.99 296.01z"
  }), React.createElement("circle", {
    cx: 265.3,
    cy: 229.08,
    r: 8.38,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1112.69 609.61a147.72 147.72 0 0 1-142.45 108.67H217.17A188.29 188.29 0 0 1 49.25 614.95s109.15-150.98 392.62-52.34c235.34 81.89 343.89 4.45 374-24.21a33.26 33.26 0 0 1 24.5-9.08c57.67 2.73 257.44 16.71 272.35 80.27aNaN NaN 0 0 0-.03.02z",
    fill: "#fff"
  }), React.createElement("ellipse", {
    cx: 209.13,
    cy: 712.91,
    rx: 121.92,
    ry: 14.31,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M298.16 786.53s-7.91-.93-13.06-4.77l-.39-.31a4.78 4.78 0 0 0 .67-1.53 7.7 7.7 0 0 1-.85-3.48 7.81 7.81 0 0 0-.68-3.3v-5.62s-1.71-1.82-1.88-6.45-.34-27.45-.34-27.45a10.73 10.73 0 0 1-.17-3.64c.17-2.64.17-3.63.17-3.63a10 10 0 0 1-.51-4.8c.51-2-1.2-4.3-1.2-4.3l2.56-12.56s1.42-43.39-2.71-56.47v-.08-.16c.35-8.44-4.77-22.49-1.87-32.24s3.24-11.91 3.24-11.91-12.78-32.08-16-39.68c-2.23-5.24-4.54-11-6.82-14.28q-.3-.43-.6-.81c-.11-.14-.22-.28-.33-.4a8.86 8.86 0 0 0 1.23-3.82c.18-2.36-.16-5.08 1.56-6.75a13.15 13.15 0 0 1 2.11-1.41 8.47 8.47 0 0 0 3.75-8.1c-.36-2.49-1.79-4.56-3.42-6.57a18.38 18.38 0 0 0-5.62-16.82v-.94a10.53 10.53 0 0 0-2-6.39l.48.34c-.27-.24-.53-.47-.81-.7a5.65 5.65 0 0 0-1.34-1 25 25 0 0 0-26-1.35 14.51 14.51 0 0 0-5.07 4.51c-2.67 4.12-2 9.45-3.38 14.13-1.34 4.47-4.5 8.17-7.12 12.07s-4.81 8.52-3.82 13.08c.71 3.31 3.07 6.28 3 9.67a7.64 7.64 0 0 1-6.7 7.08h-.09a6.87 6.87 0 0 1-1 .08c3.18 2.19 7.13 3 11 3.51-.08.3-.16.6-.23.91C210.79 572 208 587 208 587s1.87 15.2-2.05 27.11-3.41 36.38-3.41 36.38 10.91-5.63 11.59-2 0 4.63 0 4.63 2.23 1.13 4.85 2.13l-.11 1.45-.48 6.5a7.25 7.25 0 0 0 .6 4c.94 1.82 0 6.78 0 6.78s-.8.5 0 2.82-.63 5.62-.63 5.62-1 12.4-1.13 15-3.41 10.09-3.41 10.09 2.9 3.63 0 4.13-3.24 5-3.24 5-3.41 2.81-3.41 3.8c0 0-15.34 15.55-18.92 41.17 0 0-3.58 3.31-3.07 6.45.29 1.78-.29 2.39-.85 2.59.63.08 1.32.49 1 2-.51 2.64-1.87 8.27-1.87 8.27h.24c-2.79 3.23-6.87 8.64-7.49 13.39q0 .3-.06.6l-1.54 3.47 13.47 6 1.19-1.82s6 6.78 12.79 8.26a17.2 17.2 0 0 0 3.57.39 31.52 31.52 0 0 0 11.06-2.21s4.94-6.11-7.85-7.27c0 0-7.49-8.6-6.81-12.24a35.92 35.92 0 0 0 .47-4.63v-1l.87.13.16-2.77a2.37 2.37 0 0 0 .51-1.66c0-1.15-1-1.32 0-2s1 0 1-1.65-.68-1.16.85-2.81-.17-4.63-.17-4.63 3.58-2.65 3.41-6.12 11.42-25.46 13.8-26.29 2.56-5.13 2.56-5.13 3.24.66 4.26 0 4.26-5.78 4.26-5.78 13-32.74 13.13-45.14l.85-2.81s4.95 6.45 4.26 11.08 3.78 7.93 3.78 7.93v14.06a41 41 0 0 1 .82 7.44c-.17 2.31 2 4.63 1.18 6.61s0 5.46 0 5.46-.18 4.63 0 5.95-.67 16.53 3.77 23.15c0 0 1.87 4.79 0 7.93s1.7 6.29 1.7 6.29-2.21 3.63 0 6.28a8.13 8.13 0 0 1 1.59 5.86c-.89 3.36-1.55 7.77-.06 10.84v.07l.4 4.72 13.06-1v-2.64s8.92 2.37 17.23 1.08c4.48-.69 8.78-2.45 11.41-6.21.07.05 5.35-9.04-8.97-5.57z",
    transform: "translate(-28 -86.39)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M276.78 705.84c-2.54 3.75-6.69 5.5-11 6.19-8 1.28-16.63-1.08-16.63-1.08v2.66l-12.61 1-.39-4.7v-.08c-1.46-3.1-.79-7.58.09-10.95a39.8 39.8 0 0 1 1.56-4.68s10.86-9.22 14.48-2.3a11.21 11.21 0 0 0 3.19 3.64c5 3.82 12.61 4.75 12.61 4.75 13.8-3.5 8.7 5.55 8.7 5.55z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M243.2 696.79s0 8.56 6.25 8.4 7.09-3.41 5.11-5.61a27 27 0 0 1-3.46-5.09z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M189.38 722.61a29.7 29.7 0 0 1-10.71 2.2 16.8 16.8 0 0 1-3.45-.38c-6.58-1.49-12.34-8.24-12.34-8.24l-1.15 1.82-13-5.93 1.47-3.47.06-.59c.6-4.73 4.54-10.12 7.24-13.34 1.47-1.75 2.58-2.85 2.58-2.85l15.64 2.3s.06 2 0 4.44a35.45 35.45 0 0 1-.46 4.61c-.65 3.62 6.58 12.18 6.58 12.18 12.31 1.18 7.54 7.25 7.54 7.25z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M158.1 684.39a1.64 1.64 0 0 1-.82.06 2.42 2.42 0 0 1 .82-.06z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M175.72 694.16s.06 2 0 4.44l-18.4-3s.09-.35.22-.93c1.47-1.75 2.58-2.85 2.58-2.85zM255.44 695.5c-2.78 6.43-19.32 4.91-19.32 4.91a7.9 7.9 0 0 0 .09-1.57 39.8 39.8 0 0 1 1.56-4.68s10.86-9.22 14.48-2.3a11.21 11.21 0 0 0 3.19 3.64z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M255.71 693.67c-1.64 7.4-19.59 5.76-19.59 5.76a8.51 8.51 0 0 0-1.48-6.26c-2.14-2.63 0-6.25 0-6.25s-3.46-3.13-1.64-6.26 0-7.9 0-7.9c-4.29-6.58-3.46-21.73-3.64-23s0-5.92 0-5.92-.81-3.46 0-5.44-1.3-4.28-1.14-6.58a42.58 42.58 0 0 0-.79-7.41v-14s-4.31-3.29-3.65-7.9-4.12-11-4.12-11l-.82 2.8c-.16 12.34-12.67 44.93-12.67 44.93s-3.13 5.11-4.12 5.77-4.11 0-4.11 0-.17 4.28-2.47 5.1-13.5 22.71-13.33 26.17-3.3 6.09-3.3 6.09 1.65 3 .17 4.61-.83 1.15-.83 2.8 0 1-1 1.64 0 .83 0 2a2.34 2.34 0 0 1-.5 1.64l-.15 2.77-19.27-3.09s1.32-5.6 1.81-8.24c.29-1.54-.38-1.95-1-2 .55-.2 1.11-.81.83-2.57-.5-3.13 3-6.42 3-6.42 3.46-25.52 18.27-41 18.27-41 0-1 3.29-3.78 3.29-3.78s.33-4.45 3.13-4.94 0-4.12 0-4.12 3.13-7.4 3.29-10 1.09-15 1.09-15 1.38-3.29.61-5.59 0-2.8 0-2.8.93-4.94 0-6.75a7.4 7.4 0 0 1-.58-3.95l.47-6.48.68-9.65s51.21-8.84 56.85-1.77a9 9 0 0 1 1.33 2.88c4 13 2.62 56.21 2.62 56.21l-2.47 12.51s1.65 2.31 1.16 4.28a10.17 10.17 0 0 0 .49 4.78s0 1-.17 3.62a11 11 0 0 0 .17 3.62s.16 22.71.33 27.32 1.81 6.42 1.81 6.42v5.6a8.09 8.09 0 0 1 .65 3.29 7.75 7.75 0 0 0 .79 3.46z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M178.67 724.83a16.8 16.8 0 0 1-3.45-.38c-6.58-1.49-12.34-8.24-12.34-8.24l-1.15 1.82-13-5.93 1.47-3.49.06-.59 13.44 6.85s10.73 5.14 14.97 9.96zM265.76 712.03c-8 1.28-16.63-1.08-16.63-1.08v2.66l-12.61 1-.39-4.7c4 .07 10.43.14 13.23-.08a61.41 61.41 0 0 1 16.4 2.2zM164.54 680.15a4.52 4.52 0 0 1 1.94.25 13.52 13.52 0 0 1 1.84 1.32 7.6 7.6 0 0 1 1.22.81c.48.47.68 1.17 1.16 1.64.88.87 2.33.67 3.5 1.09.13 0 .27.11.29.24s-.09.24-.2.32a1.92 1.92 0 0 1-1.9 0 7.64 7.64 0 0 1-1.59-1.2 10.75 10.75 0 0 0-3.09-1.92c-1.55-.61-4.25-.78-5.23-2.3.46-.35 1.46-.24 2.06-.25zM163.22 683.61a4.72 4.72 0 0 1 1 .41l1.69.85a6.26 6.26 0 0 1-3.45-.77 9.93 9.93 0 0 1-1.09-.52 5.58 5.58 0 0 1 1.85.03zM165.45 686.49a4.5 4.5 0 0 1 1.1.09 5.47 5.47 0 0 1 1.74 1 6.8 6.8 0 0 0 4.36 1.51 1.9 1.9 0 0 1-1 .17h-3.54a4.7 4.7 0 0 1-2.64-.61c-.6-.29-3.08-1-3.1-1.83s2.48-.33 3.08-.33zM246 690.69a19.71 19.71 0 0 0 3.26.09 6.23 6.23 0 0 0 3.22-1c.95-.73.75-1.48-.46-1.53a8.63 8.63 0 0 0-3.25.8 9.86 9.86 0 0 0-1.52.77c-.25.11-1.07.88-1.25.87zM249.94 692.49c-.1.4-.52.62-.9.77a10.32 10.32 0 0 1-2.9.64c-.25 0-.95 0-.86-.39s1.13-.27 1.38-.3a25 25 0 0 0 3.28-.72zM240.06 691.84a6.69 6.69 0 0 1 4 .79.2.2 0 0 1 .08.1.1.1 0 0 1 0 .09 1.37 1.37 0 0 1-1.34.72 6.26 6.26 0 0 1-1.56-.39 8.08 8.08 0 0 0-2.58-.39 6.51 6.51 0 0 1-1.17 0c-1.16-.2-.78-.67.11-.77a23.49 23.49 0 0 1 2.46-.15zM194.84 627.16a10.18 10.18 0 0 0-5.62-1.84 8 8 0 0 1 5.62 1.84zM193.3 620.52a8.11 8.11 0 0 1 4.2 1.2l-1.52-.42a14.34 14.34 0 0 0-2.81-.59c-.55-.05-1.1 0-1.65-.06s-1.25-.16-1.87-.18c1.21.06 2.43-.01 3.65.05zM198.25 623.68c.46.09 1 .29 1.1.76 0-.28-3.26-1.2-3.66-1.33-.67-.24-2.82-1.18-3.31-.53 1.89.51 3.93.7 5.87 1.1zM202.83 609.06a13.79 13.79 0 0 0 5.67-3.64 4.5 4.5 0 0 1-2.09 3.7 11.78 11.78 0 0 1-4.13 1.54 18.2 18.2 0 0 0-4.24 1.27c-.65.33-2.68 2.25-3.32 2.15-.81-.12.48-1.4.78-1.63 2.14-1.67 4.85-2.41 7.33-3.39zM243.16 630.41c-.7-.24-9.2 1.41-8.68-.24.32-1 3.08-.64 3.77-.61a17.45 17.45 0 0 1 4.91.85z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M234 433.61a18.76 18.76 0 1 1-5.66-13.43 18.62 18.62 0 0 1 5.66 13.43z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M224.93 441.34s-6.09 17.78-2.63 21.4-24.86 5.76-24.86 5.76 11.85-21.23 10.7-26.5 16.79-.66 16.79-.66z",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M250.29 562.61v1.24c-.33 8.4-15.31 25.35-18.77 22.55s-27-8.4-27-8.4-3.46-5.43-7.08-5.43a18.51 18.51 0 0 1-5.95-1.54l.68-9.65s51.19-8.77 56.83-1.7a9 9 0 0 1 1.29 2.93z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M250.28 562.32c-.17 4.21-4 10.56-8.23 15.5s-8.81 8.44-10.54 7a16.62 16.62 0 0 0-4.08-1.93c-7.79-2.87-22.91-6.47-22.91-6.47s-3.46-5.43-7.08-5.43-10.53-3.62-10.53-3.62.66-1 0-4.61-11.19 2-11.19 2-.5-24.36 3.29-36.22 2-27 2-27 2.71-14.92 5.65-26.71c1.77-7.07 3.63-13 5.05-13.94 3.79-2.47 23.54 0 23.54 0s8.23.16 11.36 1a5 5 0 0 1 2.37 1.93c.19.26.39.53.58.82 2.2 3.3 4.44 9 6.59 14.21 3.13 7.57 15.48 39.5 15.48 39.5s-.33 2.14-3.13 11.85 2.11 23.73 1.78 32.12z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M236.12 572.03l5.93 5.78s5.43 18.74-1.65 17.1-13-12-13-12z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M251.1 519.85c-14-.16-17.61-19.75-17.61-19.75s-1-19.42-2.8-23c-1-2-1.45-6.92-1.65-10.92 2.2 3.3 4.43 9 6.59 14.21 3.13 7.53 15.47 39.46 15.47 39.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M251.6 518.37c-14-.16-17.6-19.76-17.6-19.76s-1-19.42-2.8-23c-1-2-1.45-6.92-1.65-10.92 2.2 3.3 4.44 9 6.59 14.21 3.11 7.54 15.46 39.47 15.46 39.47z",
    fill: "#65617d"
  }), React.createElement("path", {
    d: "M226.54 470.05s-4.12-11.19-10.87 0-6.91 25.35-6.91 25.35l-1.15 30.94s2.14 4.12 2.06 6.42 4 8.89 4 8.89 1 13 4.77 15.14l3.62 10.7s.17 7.08 2.64 9.88 1.17 7.12 1.17 7.12l14.63-5.12s-1.65.59 0-3.83-1-10.19-1-10.19-9.38-20.41-10.53-23.37-2.8-6.42-2.14-9.88.13-40.16 1-45.75-1.29-16.3-1.29-16.3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M228.06 468.5s-4.12-11.19-10.87 0-6.91 25.35-6.91 25.35l-1.15 30.94s2.14 4.12 2.06 6.42 4 8.89 4 8.89 1 13 4.77 15.14l3.62 10.7s.17 7.08 2.64 9.88 1.18 7.12 1.18 7.12l14.62-5.13s-1.65.6 0-3.82-1-10.19-1-10.19-9.38-20.41-10.53-23.37-2.8-6.42-2.14-9.88.14-40.16 1-45.76-1.29-16.29-1.29-16.29z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M228.34 565.29a5.53 5.53 0 0 1 1.79.53c.45.24.84.59 1.28.84a3.57 3.57 0 0 0 1.69.46c-.66 0-1.32.07-2 .08a3.5 3.5 0 0 1-1.21-.15 4.92 4.92 0 0 1-1-.67 5.39 5.39 0 0 0-1.31-.72c-.35-.15-.73-.2-.88-.56a10.17 10.17 0 0 1 1.64.19zM233.91 569.71c.62 0 1.24-.14 1.87-.18a15.39 15.39 0 0 1 2.71.14 7.63 7.63 0 0 1-4.28.76 2.56 2.56 0 0 0-1.29 0c-.46.19-1.79 1.7-1.91.36s2.14-1.05 2.9-1.08zM226.34 413.86l-2.34-1.74a4.5 4.5 0 0 1 .74.33 5.46 5.46 0 0 1 1.34 1.05c.26.22.52.46.77.69zM229 463.84a5.82 5.82 0 0 1-2 2.44 4.1 4.1 0 0 1-1.76.68 6.88 6.88 0 0 1-2.66-.28 32.84 32.84 0 0 1-3.23-1 53.35 53.35 0 0 0-6.35-2.16c-3.29-.75-7.12-.48-9.48 1.92-2.07 2.11-2.58 5.39-4.65 7.5-2.77 2.82-7.31 2.65-11.24 2.1l-.92-.13c1.77-7.07 3.63-13 5.05-13.94 3.79-2.47 23.54 0 23.54 0s8.23.16 11.36 1a5 5 0 0 1 2.34 1.87zM196.46 433.61a18.76 18.76 0 0 1 31.86-13.43c.06 3.27-.65 6.62.27 9.77.85 2.93 3 5.29 4.94 7.73a18.76 18.76 0 0 1-37.07-4.07z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M226.8 413.21a23.42 23.42 0 0 0-27.21-3.06 14.09 14.09 0 0 0-4.9 4.49c-2.58 4.11-1.92 9.41-3.27 14.07-1.28 4.45-4.34 8.13-6.87 12s-4.64 8.49-3.69 13c.69 3.3 3 6.26 2.92 9.63a7.47 7.47 0 0 1-7.23 7.1c3.18 2.25 7.15 3 11 3.55s8.46.72 11.24-2.11c2.07-2.1 2.58-5.39 4.65-7.49 2.36-2.41 6.19-2.68 9.48-1.92s6.32 2.35 9.58 3.2a7.07 7.07 0 0 0 2.66.27c2.81-.38 4.44-3.5 4.66-6.32.18-2.35-.16-5.06 1.51-6.72a12.74 12.74 0 0 1 2-1.41 8.51 8.51 0 0 0 3.61-8.06c-.77-5.58-6.81-9.06-8.39-14.47-.92-3.14-.21-6.49-.27-9.76s-1.29-7-4.37-8.1",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M236.68 443.46c-.78-5.58-6.82-9.06-8.4-14.47-.92-3.14-.21-6.49-.26-9.76a10.72 10.72 0 0 0-2-6.36l.46.34q-.37-.36-.78-.69a5.28 5.28 0 0 0-1.29-1c-.28-.21-.57-.4-.85-.59l.45.41-.46-.34a10.7 10.7 0 0 1 2 6.36c0 3.26-.66 6.62.26 9.76 1.58 5.41 7.62 8.89 8.4 14.47a8.53 8.53 0 0 1-3.62 8.06 12.55 12.55 0 0 0-2 1.41c-1.66 1.66-1.33 4.37-1.51 6.72-.22 2.82-1.85 5.94-4.65 6.32a7.12 7.12 0 0 1-2.67-.27c-3.26-.85-6.29-2.45-9.58-3.2s-7.11-.49-9.48 1.92c-2.07 2.1-2.58 5.38-4.65 7.49-2.77 2.83-7.31 2.65-11.23 2.11a34.47 34.47 0 0 1-7.56-1.74 6.37 6.37 0 0 1-1 .08c3.18 2.25 7.15 3 11 3.55s8.46.72 11.23-2.11c2.07-2.1 2.58-5.39 4.65-7.49 2.37-2.41 6.2-2.68 9.48-1.92s6.32 2.35 9.58 3.2a7.12 7.12 0 0 0 2.67.27c2.8-.38 4.43-3.5 4.65-6.32.18-2.35-.15-5.06 1.51-6.72a13.21 13.21 0 0 1 2-1.41 8.52 8.52 0 0 0 3.65-8.08z",
    opacity: 0.1
  }));
};

UndrawWindTurbine.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawWindTurbine;